/**
 * useFit — shared React Query hook for portfolio fit (TASK-510).
 * Reuses the ['portfolio-fit', clientId] key already used by PersonalizationTab
 * so every summoned tile for the same client dedupes to one /fit request.
 */

import { useQuery } from '@tanstack/react-query';
import { portfolioFitService } from '../services/portfolioFitService';

export function useFit(clientId: string) {
  return useQuery({
    queryKey: ['portfolio-fit', clientId],
    queryFn: () => portfolioFitService.getFit(clientId),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });
}
